export const ADD_KNB_PAYMENT_TYPES = [
  { value: "PAY", label: "PAY" },
  { value: "NOCOUNT", label: "NO COUNT" },
  { value: "BUYBACK", label: "BUY BACK" },
];

export const USER_TABLE_COLUMNS = [
  { name: "FullName", label: "Họ và tên" },
  { name: "Phone", label: "Số Điện Thoại" },
  { name: "AccountName", label: "Tên tài khoản" },
  { name: "DateOfBirth", label: "Ngày sinh" },
  // { name: "Email", label: "Email" },
  { name: "Knb", label: "Knb" },
  { name: "KnbKhoa", label: "KnbKhoa" },
  { name: "Item", label: "Vật phấm" },
  { name: "IP", label: "IP Đăng nhập gần nhất" },
  { name: "Status", label: "Trạng thái" },
  { name: "CreatedDate", label: "Đăng nhập lần cuối" },
  { name: "Action", label: "" },
];
